<template>
  <main works-list>
    <p-section class="hero" theme="dark">
      <h2>works</h2>
      <div class="categories">
        <!--        <ScrollMenu :key="`scroll-menu-${code}`">-->
        <!--          <div class="swiper-slide" v-for="item in categories" :key="`scroll-menu-${code}-${item.code}`">-->
        <!--            <locale-link :to="item.data.route" :class="{ on: checkOn(item) }">{{ item.label }}</locale-link>-->
        <!--          </div>-->
        <!--        </ScrollMenu>-->
        <div class="col" v-for="item in categories" :key="`scroll-menu-${code}-${item.code}`">
          <locale-link :to="item.data.route" :class="{ on: checkOn(item) }">{{ item.label }}</locale-link>
        </div>
      </div>
    </p-section>
    <section class="list">
      <transition-group name="fade" tag="ul">
        <li v-for="(item, i) in list" :key="`li${i}`" :class="{ highlight: item.highlight }">
          <a @click="linkTo(`/works/article/${item.slug}`)">
            <div class="img" v-if="category === 'featured'">
              <cdn-img :src="item.image" class="hidden-tp-down" v-if="matchMediaType(item.image, 'image')"/>
              <cdn-video :src="item.image" loop autoplay muted playsinline class="hidden-tp-down" v-if="matchMediaType(item.image, 'video')"/>
              <cdn-img :src="getMobileThumb(item)" class="hidden-tl-up" v-if="matchMediaType(getMobileThumb(item), 'image')"/>
              <cdn-video :src="getMobileThumb(item)" loop autoplay muted playsinline class="hidden-tl-up" v-if="matchMediaType(getMobileThumb(item), 'video')"/>
            </div>
            <div class="img" v-else>
              <cdn-img :src="item.image" v-if="matchMediaType(item.image, 'image')"/>
              <cdn-video :src="item.image" loop autoplay muted playsinline v-if="matchMediaType(item.image, 'video')"/>
            </div>
            <div class="text">
              <p v-html="enterToBr(item.title)"></p>
            </div>
          </a>
        </li>
      </transition-group>
      <!--      <div class="view-more" v-if="paging.pageNo < paging.pageCount">-->
      <!--        <a @click="getList"><i></i><span>VIEW MORE</span><span v-if="false">{{ paging.pageNo }}/{{ paging.pageCount-->
      <!--          }}</span></a>-->
      <!--      </div>-->
      <paging-observer @show="getList"/>
    </section>
  </main>
</template>

<script>
import oax from '@/utils/oax';
import CdnImg from '@/views/components/CdnImg';
import CdnVideo from '@/views/components/CdnVideo.vue';
import PagingObserver from '@/views/components/PagingObserver.vue';

export default {
  name: 'works-list',
  components: { PagingObserver, CdnVideo, CdnImg },
  data() {
    return {
      code: null,
      list: null,
      paging: null,
    };
  },
  computed: {
    category() {
      return this.$route.params.category;
    },
    categories() {
      // return [{ label: 'All', data: { route: `/works/all` } }, ...this.codeList('works')];
      return this.codeList('works');
    },
    activeIndex() {
      return this.categories.findIndex(row => row.data.route.includes(this.category));
    },
    description() {
      if (this.category === 'all') return this.codeData(this.root)?.description || '';
      return this.categories.find(row => row.data.route.includes(this.category))?.data?.description || '';
    },
  },
  watch: {
    code: 'refresh',
  },
  methods: {
    refresh() {
      // console.log(this.activeIndex);
      //this.$refs.slider.go(this.activeIndex);
    },
    checkOn(item) {
      return this.$route.path === `${ this.$i18n('path') }${ item.data.route }`;
    },
    changedSlider(e) {
      const route = this.categories[e.realIndex].data.route;
      if (!this.$route.path.includes(route)) this.localeLink(route);
    },
    async getList() {
      if (this.paging.pageNo >= this.paging.pageCount) return;

      const { data } = await oax.get(`/api/article`, {
        lang: this.lang,
        category: this.code,
        perPage: 8,
        pageNo: this.paging.pageNo + 1,
      });

      let list = data.list;
      if (this.code === 'works-featured') {
        const hl = (await oax.get(`/api/article/highlights`, {
          lang: this.lang,
          perPage: 2,
          pageNo: this.paging.pageNo + 1,
        })).data;
        if (hl.list.length) {
          list = list.reduce((acc, cur, i) => {
            if (i % 4 === 0 && hl.list.length) {
              const item = hl.list.shift();
              item.highlight = true;
              acc.push(item);
            }
            acc.push(cur);
            return acc;
          }, []);
        }
      }

      this.list = [...this.list, ...list];
      this.paging = data.paging;
    },
    getMobileThumb(e) {
      return e.mobileThumb || e.image;
    },
  },
  mounted() {
    this.$store.commit('theme', 'dark');
  },
  async asyncData({ route, store }) {
    const lang = route.params.locale || 'ko';
    const path = route.path.replace('/all', '').replace(`/${ lang }`, '');
    const category = store.state.codes.find(row => row.data.route === path)?.code;
    if (!category) throw new Error('404');
    const info = (await oax.get(`/api/article`, { lang, category, perPage: 8 })).data;
    let list = info.list;
    if (category === 'works-featured') {
      const highlights = (await oax.get(`/api/article/highlights`, { lang, perPage: 2 })).data;
      if (highlights.list.length) {
        list = list.reduce((acc, cur, i) => {
          if (i % 4 === 0) {
            const item = highlights.list.shift();
            item.highlight = true;
            acc.push(item);
          }
          acc.push(cur);
          return acc;
        }, []);
      }
    }
    if (!info) throw new Error('404');

    return { list, paging: info.paging, code: category };
  },
};
</script>

<style lang="less">
@import '~@/less/proj.less';

[works-list] { .rel;
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.5s ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    transform: translateY(20%);
  }

  section { .space-m;
    &.hero { .pt(80); .pb(20); .sticky; .t(-133); z-index: 4; .bgc(#000);
      h2 { .fs(48, 1.2); .regular; }
      //.categories { .mt(33); .ph(20); .mh(-20); .crop;
      //  .locked .swiper-slide:last-of-type {.mr(0);}
      //  .swiper-slide { .p; overflow: hidden;
      //    a { .fs(18, 32); .block; .medium; .-b(transparent);
      //      &.on { .-b(#000); }
      //    }
      //  }
      //  .hidden-ml-down { .fs(0, 0); }
      //}
      .categories { .mt(20); .flex; justify-content: space-between;
        .col {
          a { .fs(15, 1.2); .medium; .o(.5);
            &.on { .o(1); }
          }
        }
      }
    }
    &.list { .rel;
      > ul { .rel; display: grid; grid-template-columns: 1fr; row-gap: 40px;
        > li { .rel;
          .img { aspect-ratio: 16 / 9; .crop; .br(5); }
          [cdn-img], [cdn-video] { .rel; .f; object-fit: cover; transform: scale(1); .o(1); transition: transform 1s cubic-bezier(0, 0, 0.13, 1.04), opacity .6s ease;}
          .text { .mt(15);
            p { .fs(20, 1.2); }
            p + p { .mt(12); .fs(16, 24, -0.25); }
          }
          .no-touch &:hover {
            [cdn-img], video {transform: scale(1.1);}
            &.has-video [cdn-img] { .o(0); }
          }

          &.highlight {
            .img { aspect-ratio: 4 / 5; }
          }
        }
      }
      .view-more { .tc; .pt(80);
        a { .rel;
          i { .wh(28); .ib; .vam; .contain; .no-repeat; .bg('/img/common/view-more.svg');
            .dark & { .bg('/img/common/view-more-w.svg'); }
          }
          span { .ib; .vam; .fs(20, 30); .medium;
            &:first-of-type {.mh(20);}
          }
          &:after {content: ''; .abs; .w(0); .h(2); .bgc(#fff); .lb(0, -10); transition: width .6s cubic-bezier(0.4, -0.03, 0, 1.03);}
          .no-touch &:hover {
            &:after { .wf; }
          }
        }
      }
    }
  }
}
@media (min-width: @screen-tp-min) {
  [works-list] {
    section {
      &.list {
        .view-more { .pt(100); }
      }
    }
  }
}
@media (min-width: @screen-tl-min) {
  [works-list] {
    section {
      &.hero { .pb(24); .t(-165);
        h2 { .fs(80, 1.2); }
        .categories {
          .col {
            a { .fs(20, 1.2); }
          }
        }
      }
      &.list {
        > ul { grid-template-columns: 1fr 1fr; column-gap: 20px; row-gap: 60px;
          > li {
            &.highlight { grid-column: span 2;
              .img { aspect-ratio: 16 / 9; }
            }
            .text { .mt(20);
              p { .fs(22, 1.2); }
            }
          }
        }
      }
    }
  }
}
@media (min-width: @screen-dm-min) {
  [works-list] {
    section { .space-d;
      &.hero { .t(-195);
        .categories { .mt(50);
          .swiper-slide {
            a { .fs(24, 32); }
          }
        }
      }
      &.list {
        .view-more { .pt(100); }
        > ul {
          > li {
            .text {
              p { .fs(26, 1.2); }
            }
          }
        }
      }
    }
  }
}
@media (min-width: @screen-dx-min) {
  [works-list] {
    section {
      &.hero { .pt(100); .t(-240);
        h2 { .fs(120, 1); }
      }
      &.list {
        .view-more { .pt(160); }
      }
    }
  }
}

</style>